import styled from 'styled-components';

export const SummaryLayout = styled.div`
  max-width: 40rem;
  padding: 1.5rem;
`;

export const DocumentList = styled.div`
  margin: 1.5rem 0 0.5rem;
`;

// Figma 23:7101–23:7189 (composed over the FA Submission Review shell): hairline
// rows of doc short-id | amount | Edit, like the Manually Ruled list.
export const DocumentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 4rem;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};
`;

export const DocShortId = styled.span`
  text-decoration: underline;
  font-size: 14px;
`;

// CSS-only hover card on the document id, same trigger pattern as the fraud
// review's OfferLetterTooltip pair; :focus-visible keeps it keyboard-reachable.
// The card body is the proof thumbnail, like the fraud review's ProofPreview.
export const DocIdTooltipWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-self: start;

  > span:hover + div,
  > span:focus-visible + div {
    opacity: 1;
    visibility: visible;
  }
`;

export const DocIdTooltipContent = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  /* Letter-page proportions at a size that reads without covering the table. */
  width: 260px;
  height: 340px;
  padding: 8px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s, visibility 0.15s;
  pointer-events: none;
`;

export const DocPreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top;
`;

export const DocPreviewEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.color.gray[400]};
  font-size: 14px;
  text-align: center;
`;

// The middle grid cell: institution name (or the Rejected tag) plus the 90-day tag.
export const DocMetaCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
  min-width: 0;
`;

export const DocumentEditButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.blue[600]};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  justify-self: end;

  &:hover {
    background: ${({ theme }) => theme.color.blue[75]};
  }
`;

// Sits inside the DocumentRow grid: span the full width so the labels read as a
// sub-line of the row, matching the ViolationList type scale.
export const DocumentReasonList = styled.ul`
  grid-column: 1 / -1;
  list-style: none;
  margin: 0.25rem 0 0;
  padding: 0;

  li {
    font-size: 14px;
    color: ${({ theme }) => theme.color.gray[700]};
    margin-bottom: 0.125rem;
  }
`;

export const TotalRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 4rem;
  align-items: center;
  padding: 1.25rem 0;
`;

export const ViolationList = styled.ul`
  margin: 1rem 0;
  padding-left: 1.25rem;

  li {
    color: ${({ theme }) => theme.color.red[700]};
    margin-bottom: 0.25rem;
  }
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-top: 1rem;
`;
